import { createHOC } from 'vue-hoc';

import withUser from '../../../../lib/common/hoc/withUser';

import EmailVerificationForm from './EmailVerificationForm';
import auth from "../../../../lib/common/providers/auth";
import userManagement from "../../../../lib/common/providers/userManagement";
import authConfig from '../../../../lib/common/providers/auth.json';

const options = {
  name: 'EmailVerificationFormContainer',
  data() {
    return {
      state: {
        loading: false,
        error: null,
        verified: true,
        verificationEmailSent: false,
      },
    };
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.replace({ name: "login" });
      return;
    }
    if (await auth.isEmailVerified()) {
      // Redirect to authoring tool if email is verified
      window.location.replace(process.env.VUE_APP_AUTHORING_TOOL_REDIRECT);
    } else {
      this.state.verified = false;
    }
  }
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
    verified() {
      return this.state.verified;
    },
    verificationEmailSent() {
      return this.state.verificationEmailSent;
    }
  },
  listeners: {
    async resendVerificationEmail() {
      this.state.error = null;
      this.state.loading = true;
      try {
        this.state.verificationEmailSent = false;
        this.state.loading = true;
        const authResult = JSON.parse(localStorage.getItem('vrpatients::auth::result'));
        await userManagement.post('/jobs/verification-email', {
          user_id: authResult.idTokenPayload.sub,
          client_id: authConfig.clientId
        });
        this.state.verificationEmailSent = true;
      } catch(e) {
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const EmailVerificationFormContainer = createHOC(EmailVerificationForm, options, renderWith);
export default withUser()(EmailVerificationFormContainer);
